// innerNode={innerNode} updateNode={updateNode} setUpdateNode={setUpdateNode} setIsChanged={setIsChanged}
import React from "react";
import editStyle from "../../../css/edittriple.module.css";

function EditInteger(props) {


    const handleChangeValue = (value) => {
        props.setUpdateNode({...props.updateNode, value: value})
        props.setIsChanged(true)
    }

    const handleChangeType = (type) => {
        props.setUpdateNode({...props.updateNode, value: "", valueType: type})
        // setNewTripleValue(this.state.value || "")
        props.setIsChanged(false)
        props.setShowSaveButton(true)
    }


    return (
        <label className={editStyle.editInline}>
            <input name={props.id} type={"radio"} value={"Integer"}
                   checked={props.updateNode.valueType === "Integer"}
                   onChange={() => handleChangeType("Integer")}/>
            &nbsp;{props.innerNode.value}&nbsp;&nbsp;
            {props.updateNode.valueType === "Integer" &&
            <input type={"number"} step={"1"} value={props.updateNode.value}
                   onChange={e => handleChangeValue(parseInt(e.target.value))}/>
            }
        </label>
    )
}
export default EditInteger
